// admin/src/utils/adminFetch.js

const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Wrapper around fetch for admin API calls
 * Automatically adds authentication headers
 */
export async function adminFetch(endpoint, options = {}) {
  // Get the admin secret from the options or from localStorage
  const adminSecret = options.secret || options.adminSecret || localStorage.getItem('changeme');
  
  const config = {
    method: options.method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      // Use x-admin-secret header as expected by server
      ...(adminSecret && { 'x-admin-secret': adminSecret }),
      ...options.headers
    }
  };

  // Handle body
  if (options.body) {
    if (typeof options.body === 'string') {
      config.body = options.body;
    } else if (typeof options.body === 'object') {
      config.body = JSON.stringify(options.body);
    }
  }

  const url = endpoint.startsWith('http') ? endpoint : `${API_ROOT}${endpoint}`;
  
  console.log('adminFetch called:', {
    path: endpoint,
    method: config.method,
    hasSecret: !!adminSecret
  });
  
  const response = await fetch(url, config);

  // Handle non-JSON responses
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    const data = await response.json();
    
    if (!response.ok) {
      console.error('adminFetch error:', { status: response.status });
      throw new Error(data.error || `Request failed with status ${response.status}`);
    }
    
    return data;
  }

  // For non-JSON responses
  if (!response.ok) {
    console.error('adminFetch error:', { status: response.status });
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response;
}